// this script adds 'mobile-device' or 'desktop-device' to element with class in array
// detection is based on likelihood that if these criteria are met, 
// (touch capable + certain screen sizes)
// then the device could be classified as mobile

function addDeviceClassBasedOnWidthTouch() {
    var isTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0);
    var isMobileSize = window.innerWidth < 1200; 
    var hasMobileOrientation = window.matchMedia("(orientation: portrait)").matches; // user agent + width to check for mobile device

    // likely mobile if touch-enabled + has mobile size or orientation
    var isLikelyMobile = isTouch && (isMobileSize || hasMobileOrientation);

    // add class to target here
    var targetClasses = [
        'gsw-header'
    ];

    // add device class
    function updateDeviceClass(element) {
        if (isLikelyMobile) {
            element.classList.add('mobile-device');
            element.classList.remove('desktop-device');
        } else {
            element.classList.add('desktop-device');
            element.classList.remove('mobile-device');
        }
    }

    targetClasses.forEach(function(className) {
        // target elems with class name from array
        var elements = document.querySelectorAll('.' + className);
        elements.forEach(updateDeviceClass);
    });
}

window.addEventListener('load', addDeviceClassBasedOnWidthTouch);
window.addEventListener('resize', addDeviceClassBasedOnWidthTouch);


